import { create } from 'zustand'

type CreditRechargeDialogState = {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
}

/** 高成本 AI 能力共用的点数充值入口。 */
export const useCreditRechargeDialogStore = create<CreditRechargeDialogState>((set) => ({
  open: false,
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
}))
